import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, useApiMutation} from './api';
import {
  GetApiKeys,
  CreateApiKey,
  DeleteApiKey,
} from '../../shared/api/definitions/apiKey';

export const useGetApiKeys = createApiQuery(GetApiKeys, () => ['apiKeys']);

export function useCreateApiKey() {
  const queryClient = useQueryClient();
  return useApiMutation(CreateApiKey, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['apiKeys'],
      });
    },
  });
}

export function useDeleteApiKey() {
  const queryClient = useQueryClient();
  return useApiMutation(DeleteApiKey, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['apiKeys'],
      });
    },
  });
}
